import type { ImpersonationSelectDto } from '@@types/api.types';

// Warning threshold: show timer + extend button when less than 5 minutes remain
const EXPIRY_WARNING_SECONDS = 5 * 60;

/**
 * Check if impersonation is about to expire (within warning threshold)
 */
export function isImpersonationExpiringSoon(impersonation: ImpersonationSelectDto | undefined): boolean {
  if (!impersonation?.expiresAt) return false;

  const expiresAt = new Date(impersonation.expiresAt).getTime();
  const now = Date.now();

  return expiresAt - now < EXPIRY_WARNING_SECONDS * 1000 && expiresAt > now;
}

/**
 * Get remaining time in seconds
 */
export function getImpersonationRemainingSeconds(impersonation: ImpersonationSelectDto | undefined): number {
  if (!impersonation?.expiresAt) return 0;

  const expiresAt = new Date(impersonation.expiresAt).getTime();
  const remaining = Math.max(0, expiresAt - Date.now());

  return Math.floor(remaining / 1000);
}

/**
 * Format remaining seconds as human-readable string
 */
export function formatRemainingTime(seconds: number): string {
  if (seconds <= 0) return 'Expired';

  const minutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  if (minutes > 0) {
    return `${minutes}m ${secs}s`;
  }
  return `${secs}s`;
}
